import type { FC, ReactElement } from 'react';

import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import type { CoreDispatch } from '../../../store/CoreStore';
import { useCoreDispatch } from '../../../store/CoreStore';
import { gameStateActions } from '../../../store/slices/game/slice';
import { usePopupSlice } from '../../../store/slices/popup/selectors';
import { popupActions } from '../../../store/slices/popup/slice';
import { Button, ButtonVariant } from '../../controls/button/Button';
import { PopupType } from '../../popup/types';

import { BlockingModalContent } from './BlockingModalContent';

export const InactivityConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();
  const currentPopupData = usePopupSlice.currentPopupData();
  const isPriveTable = Boolean(currentPopupData?.privateTable);
  const action = [
    <Button
      key="OK"
      tk="OK"
      variant={ButtonVariant.ACCENT}
      onClick={() => {
        dispatch(popupActions.dismissPopup(PopupType.Inactivity));
        inactivityConnectedOnClose(dispatch);
      }}
    />,
  ];

  return (
    <BlockingModalContent actions={action}>
      <L10nText tk={isPriveTable ? 'PRIVATE_SESSION_POPUP' : 'IDLE_MESSAGE'} />
    </BlockingModalContent>
  );
};

export const inactivityConnectedOnClose = (dispatch: CoreDispatch): void => {
  // Resume game socket and video stream
  dispatch(gameStateActions.setGamePaused(false));
  dispatch(gameStateActions.setInactivityCounter(0));
};
